import React from "react";

/**
 * Catch runtime errors in the React tree and render a soft, on-brand fallback
 * instead of a white screen. Reload button gives the user a way forward.
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: "" };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, message: error?.message || "" };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("Pax error boundary caught:", error, info);
    }

    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-bone">
                <img src="/pax-logo.png" alt="Pax" className="w-16 h-16 object-contain mb-6 opacity-80" />
                <p className="text-xs uppercase tracking-[0.3em] text-inkSoft mb-4 font-body">something went quiet</p>
                <h1 className="font-heading text-3xl tracking-tight text-ink mb-4">
                    Pax needs a breath.
                </h1>
                <p className="font-body text-inkSoft max-w-md mb-8">
                    an unexpected error happened while rendering. a refresh usually helps.
                </p>
                <button
                    data-testid="error-boundary-reload"
                    onClick={() => window.location.reload()}
                    className="bg-terracotta text-bone px-6 py-3 rounded-full hover:bg-terracottaHover transition-colors font-body"
                >
                    reload
                </button>
                {this.state.message && (
                    <p className="mt-8 text-xs text-inkSoft/70 font-mono max-w-xl truncate">
                        {this.state.message}
                    </p>
                )}
            </div>
        );
    }
}
